export default __webpack_public_path__ + "static/thumb-7-32304367c9572a761cc4b4d577743ee6.jpg";